import { modalOnDemand } from 'javascripts/general_scripts'

if (!window.dataLayer[0].signedIn) {
  modalOnDemand('.gitb-modal-register-open', '/login_modal.json',  async function() {
    await import('javascripts/modal_register')
  })
}